import {
  Grid,
  Typography,
  Modal,
  Tabs,
  Tab,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { Header, HeaderActionType } from "../Components/Header";
import { isTokenValid } from "../helpers";
import { HEADER_HEIGHT } from "../constants";
import { AdminUsers } from "../Components/AdminUsers";
import { AdminGroups } from "../Components/AdminGroups";


enum ActiveTab {
  USERS,
  GROUPS,
  SCENES,
  ASSETS,
}

export const Admin = () => {
  const isLoggedIn = useMemo(() => isTokenValid(), [localStorage.getItem("jwt")]);
  const [selectedTab, setSelectedTab] = useState<ActiveTab>(ActiveTab.USERS);
  
  return (
    <Grid
      sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
      })}
    >
      <Header
        isLoggedIn={isLoggedIn}
        activeActions={[HeaderActionType.LOGIN, HeaderActionType.WORKSPACE, HeaderActionType.DASHBOARD]}
        drawerOpen={false}
      />

      <Grid
        container
        spacing={4}
        direction="column"
        pt={`${HEADER_HEIGHT + 15}px`}
        style={{ minHeight: '100vh' }}
      >
        {/* Title + Create button */}
        <Grid container justifyContent="center" spacing={2} mb={4}>
          <Grid size={11}>
            <Typography
              // align="center"
              variant="h4"
              color="primary"
              gutterBottom
            >
              Admin Actions
            </Typography>
          </Grid>
          <Tabs
            value={selectedTab}
            onChange={(_, value) => {
              setSelectedTab(value as unknown as ActiveTab);
            }}
          >
            <Tab label="Users" value={ActiveTab.USERS} />
            <Tab label="Groups" value={ActiveTab.GROUPS} />
            {/* <Tab label="Scenes" value={ActiveTab.SCENES} /> // TODO - implement
            <Tab label="Assets" value={ActiveTab.ASSETS} /> */}
          </Tabs>
          {selectedTab === ActiveTab.USERS && (
            <AdminUsers />
          )}
          {selectedTab === ActiveTab.GROUPS && (
            <AdminGroups />
          )}
        </Grid>
      </Grid>

      {/* Add modal */}
      <Modal
        open={false}
        onClose={() => {
        }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Grid
          sx={(theme) => ({
            backgroundColor: theme.palette.background.paper,
            borderRadius: 2,
            padding: 3,
            minWidth: 400,
            boxShadow: 24,
            outline: "none",
            display: "flex",
            flexDirection: "row",   // stack vertically
            gap: 4,                 // space between children
          })}
        >

        </Grid>
      </Modal>
    </Grid>
  )
}